export default class helper {
    
    static WithComma(value,digit=0) {
       
        if(value == 0){
            return 0
        }
        if(value == "" || value == null) {
            return ""
        }
        if(!this.IsNumber(value)){
            return ""
        }
      
        return Number(value).toLocaleString('en-US', {
          minimumFractionDigits: digit,
          maximumFractionDigits: digit
      });
    }

    static WithComma2(value) {
       
        if(value == 0){
            return value
        }
        if(!value || !this.IsNumber(value)) {
            return ""
        }
        
        if(value.toString().includes('.') == -1){
            let [val1,val2] = value.toString().split('.')
            let number = Number.parseFloat(val1.toString().replace(/,/g,""))
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+"." + val2
        }
        else{
            let number = Number.parseFloat(value.toString().replace(/,/g,""))
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    }

    static Int(value) {
        if(!value) return 0
        return Number.parseInt(value.toString().replace(/,/g,""))
    }

    static Float(value) {
        if(!value) return 0
        return Number.parseFloat(value.toString().replace(/,/g,""))
    }

    static Decimal(value,digit = 2) {
        if(!value) return 0
        return value.toFixed(digit)
    }

    static Date(value){
        if (!value) return ''
        return value.toString().split('-').reverse().join('/')
    }

    static DateNoTime(value){
        if (!value) return ''
        return value.toString().substr(0,10).split('-').reverse().join('/')
    }

    static IsNumber(value){
        if(!value) return false
        return isNaN(value.toString().replace(/,/g,'')) ? false : true
    }

    static DateThai(dateStr){
        let month = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"]
        let[y,m,d] = dateStr.split('-')
        return parseInt(d) + ' ' + month[parseInt(m) - 1] + ' ' + 'พ.ศ.' + ' ' + (parseInt(y) + 543)
    }

    static DateEngShort(dateStr){
        let month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
        let[y,m,d] = dateStr.split('-')
        return month[parseInt(m) - 1] + ' ' + y
    }

    static SplitColumn(arr, size){
        var index = 0;
        var arrayLength = arr.length;
        var tempArray = [];

        for (index = 0; index < arrayLength; index += size) {
            var chunk = arr.slice(index, index + size);
            tempArray.push(chunk);
        }

        return tempArray;
    }
}


// WEBPACK FOOTER //
// ./src/classes/helper.js